import { FieldValues, Path, UseFormReturn, useWatch } from "react-hook-form";
import { LabelAndSelect } from "../reuseables/form.comp";
import MultipleProductsSelector from "../reuseables/multipleProductsSelector";

type ProductRestrictionFormProps<T extends FieldValues> = {
  methods: UseFormReturn<T>;
  typeFieldName: Path<T>;
  idsFieldName: Path<T>;
};

export default function ProductRestrictionForm<T extends FieldValues>({
  methods,
  typeFieldName,
  idsFieldName,
}: ProductRestrictionFormProps<T>) {
  const restrictionType = useWatch({
    name: typeFieldName,
    control: methods.control,
  });

  return (
    <div>
      <LabelAndSelect
        methods={methods}
        label={"Product Restriction"}
        topLabelCss="block w-full"
        fieldName={typeFieldName}
        options={[
          { label: "None", value: "none" },
          { label: "Inclusion", value: "inclusion" },
          { label: "Exclusion", value: "exclusion" },
        ]}
      />

      {restrictionType && restrictionType !== "none" ? (
        <div className="space-y-4">
          <MultipleProductsSelector methods={methods} fieldName={idsFieldName} showVariants={true} btnId="add-product-restriction-btn" />
        </div>
      ) : null}
    </div>
  );
}
